import { render, staticRenderFns } from "./addAds.vue?vue&type=template&id=aea349c4&scoped=true&"
import script from "./addAds.vue?vue&type=script&lang=js&"
export * from "./addAds.vue?vue&type=script&lang=js&"
import style0 from "./addAds.vue?vue&type=style&index=0&id=aea349c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aea349c4",
  null
  
)

export default component.exports